import { authorizeMe, axiosInstance } from './commonHeadApiLogic.js';

const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};

export const getEditingPlansAPI = (page = 1, limit = 10, category = '') => {
  const url = category 
    ? `/api/admins/editing-plans/${category}?page=${page}&limit=${limit}`
    : `/api/admins/editing-plans?page=${page}&limit=${limit}`;
  return withAuthorization(() => axiosInstance.get(url));
};

export const createEditingPlanAPI = (payload) => {
  return withAuthorization(() =>
    axiosInstance.post(`/api/admins/editing-plans`, payload)
  );
};

export const updateEditingPlanAPI = (id, payload) => {
  return withAuthorization(() =>
    axiosInstance.put(`/api/admins/editing-plans/${id}`, payload)
  );
};

export const deleteEditingPlanAPI = (id) => {
  return withAuthorization(() =>
    axiosInstance.delete(`/api/admins/editing-plans/${id}`)
  );
};
